module.exports = __webpack_public_path__ + "static/media/exc_per_wor.d2573db8.png";